import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DraftComponent } from './components/draft/draft.component';
import { DraftResultComponent } from './components/draft-result/draft-result.component';
import { DraftQueueComponent } from './components/draft-queue/draft-queue.component';
import { MatComponentsModule } from 'app/modules/mat-components/mat-components.module';
import { AuthGuard } from 'app/shared/services/Guards/Auth-Guard/auth-guard.service';
import { SharedModule } from 'shared/shared.module';
import { MdTabNavigationComponent } from '../md-tab-navigation/md-tab-navigation.component';
import { StartDraftDialogComponent } from 'app/modules/draft/components/draft-game/start-draft-dialog/start-draft-dialog.component';
import { QueueWelcomeComponent } from 'app/modules/draft/dialogs/queue-welcome-container/queue-welcome.component';
import { OnboardingGuard } from 'shared/services/Guards/Onboarding/onboarding-guard.component';
import { DraftGameComponent } from './components/draft-game/draft-game.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MatComponentsModule,
    RouterModule.forChild([
      {
        path: 'draft',
        component: MdTabNavigationComponent,
        children: [
          { path: '', component: DraftComponent, canActivate: [AuthGuard, OnboardingGuard] },
        ]
      }
    ])
  ],
  entryComponents: [
    QueueWelcomeComponent,
  ],
  declarations: [
    DraftResultComponent,
    DraftQueueComponent,
    DraftComponent,
    StartDraftDialogComponent,
    QueueWelcomeComponent,
    DraftGameComponent,
  ],
})
export class DraftModule { }



// WEBPACK FOOTER //
// ./src/app/modules/draft/draft.module.ts